// GENERATED by scripts/build_basemap_styles.mjs — do not edit by hand.
// Self-hosted basemap (PMTiles worker over R2), split into a nolabels
// style and a labels-only style to mirror the Carto pane architecture.
// To change the look, edit in the maptiles/ style editor and rerun.
export const BASEMAP_STYLE = {
  "version": 8,
  "glyphs": "https://fincuvagermany.com/fonts/{fontstack}/{range}.pbf",
  "sources": {
    "omt": {
      "type": "vector",
      "url": "https://tiles.fincuvagermany.com/germany-2026-08.json"
    },
    "germany": {
      "type": "geojson",
      "data": "/germany.json"
    },
    "world": {
      "type": "vector",
      "tiles": [
        "https://fincuvagermany.com/world/{z}/{x}/{y}.mvt"
      ],
      "maxzoom": 6
    }
  },
  "layers": [
    {
      "id": "ocean",
      "type": "background",
      "paint": {
        "background-color": "#e3e7ea"
      }
    },
    {
      "id": "world-land",
      "type": "fill",
      "source": "world",
      "source-layer": "land",
      "paint": {
        "fill-color": "#f4f3f0"
      }
    },
    {
      "id": "world-river",
      "type": "line",
      "source": "world",
      "source-layer": "river",
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#c9d8e3",
        "line-width": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          3,
          0.5,
          6,
          1.4
        ]
      }
    },
    {
      "id": "world-boundary",
      "type": "line",
      "source": "world",
      "source-layer": "boundary",
      "paint": {
        "line-color": "#d6d2cc",
        "line-width": 0.8
      }
    },
    {
      "id": "land",
      "type": "fill",
      "source": "germany",
      "paint": {
        "fill-color": "#ffffff"
      }
    },
    {
      "id": "landuse-residential",
      "type": "fill",
      "source": "omt",
      "source-layer": "landuse",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "residential",
            "suburb",
            "neighbourhood",
            "commercial",
            "industrial",
            "retail"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "#ffffff",
        "fill-opacity": 0.6
      }
    },
    {
      "id": "landcover-green",
      "type": "fill",
      "source": "omt",
      "source-layer": "landcover",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "wood",
            "grass",
            "farmland"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "#f4f8f1",
        "fill-opacity": [
          "match",
          [
            "get",
            "class"
          ],
          "farmland",
          0.35,
          "grass",
          0.6,
          0.75
        ],
        "fill-antialias": false
      }
    },
    {
      "id": "park",
      "type": "fill",
      "source": "omt",
      "source-layer": "park",
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "#f4f8f1",
        "fill-opacity": 0.75
      }
    },
    {
      "id": "water",
      "type": "fill",
      "source": "omt",
      "source-layer": "water",
      "paint": {
        "fill-color": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          5.5,
          "#e3e7ea",
          6.75,
          "#a4ccdf"
        ],
        "fill-antialias": true
      }
    },
    {
      "id": "waterway",
      "type": "line",
      "source": "omt",
      "source-layer": "waterway",
      "paint": {
        "line-color": "#a4ccdf",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          8,
          0.5,
          12,
          1.2,
          14,
          2.5,
          18,
          6
        ]
      }
    },
    {
      "id": "building",
      "type": "fill",
      "source": "omt",
      "source-layer": "building",
      "minzoom": 13,
      "layout": {
        "visibility": "visible"
      },
      "paint": {
        "fill-color": "#e6e4e0",
        "fill-opacity": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          13,
          0.4,
          15,
          0.9
        ],
        "fill-outline-color": "rgba(0,0,0,0.06)"
      }
    },
    {
      "id": "road-minor",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "minzoom": 11,
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "minor",
            "service",
            "track",
            "path",
            "unclassified"
          ]
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#d6d6d6",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          12,
          0.1,
          14,
          0.28,
          16,
          0.6,
          18,
          2
        ]
      }
    },
    {
      "id": "road-major-casing",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "primary",
            "secondary",
            "tertiary"
          ]
        ]
      ],
      "layout": {
        "line-cap": "butt",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#d8d8d4",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          8,
          0.3,
          11,
          0.42,
          14,
          0.78,
          18,
          2.98
        ]
      }
    },
    {
      "id": "road-major",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "primary",
            "secondary",
            "tertiary"
          ]
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#ebebeb",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          8,
          0.12,
          11,
          0.24,
          14,
          0.6,
          18,
          2.8
        ]
      }
    },
    {
      "id": "road-motorway-casing",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "motorway",
            "trunk"
          ]
        ]
      ],
      "layout": {
        "line-cap": "butt",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#d0d0cc",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          6,
          0.51,
          10,
          0.81,
          14,
          1.62,
          18,
          5.67
        ]
      }
    },
    {
      "id": "road-motorway",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "motorway",
            "trunk"
          ]
        ]
      ],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#e6e6e6",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          6,
          0.24,
          10,
          0.54,
          14,
          1.35,
          18,
          5.4
        ]
      }
    },
    {
      "id": "railway",
      "type": "line",
      "source": "omt",
      "source-layer": "transportation",
      "minzoom": 10,
      "filter": [
        "==",
        [
          "get",
          "class"
        ],
        "rail"
      ],
      "paint": {
        "line-color": "#d3d1cd",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          10,
          0.6,
          14,
          1.2,
          18,
          3
        ],
        "line-dasharray": [
          3,
          2
        ]
      }
    },
    {
      "id": "boundary-state",
      "type": "line",
      "source": "omt",
      "source-layer": "boundary",
      "filter": [
        "all",
        [
          "==",
          [
            "get",
            "admin_level"
          ],
          4
        ],
        [
          "!=",
          [
            "get",
            "maritime"
          ],
          1
        ]
      ],
      "layout": {
        "visibility": "none"
      },
      "paint": {
        "line-color": "#a5a2b8",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          4,
          0.6,
          10,
          1.4,
          14,
          2.2
        ],
        "line-dasharray": [
          3,
          2
        ],
        "line-opacity": 0.7
      }
    },
    {
      "id": "boundary-country",
      "type": "line",
      "source": "omt",
      "source-layer": "boundary",
      "filter": [
        "all",
        [
          "==",
          [
            "get",
            "admin_level"
          ],
          2
        ],
        [
          "!=",
          [
            "get",
            "maritime"
          ],
          1
        ]
      ],
      "layout": {
        "visibility": "none"
      },
      "paint": {
        "line-color": "#a5a2b8",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.4
          ],
          [
            "zoom"
          ],
          4,
          1,
          10,
          2.2,
          14,
          3.5
        ]
      }
    },
    {
      "id": "world-city",
      "type": "symbol",
      "source": "world",
      "source-layer": "city",
      "minzoom": 3,
      "layout": {
        "text-field": [
          "get",
          "name"
        ],
        "text-font": [
          "Noto Sans Regular"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          3,
          9,
          6,
          11.5
        ]
      },
      "paint": {
        "text-color": "#a29d95",
        "text-halo-color": "rgba(255,255,255,0.9)",
        "text-halo-width": 1.1
      }
    }
  ]
};

export const BASEMAP_LABELS_STYLE = {
  "version": 8,
  "glyphs": "https://fincuvagermany.com/fonts/{fontstack}/{range}.pbf",
  "sources": {
    "omt": {
      "type": "vector",
      "url": "https://tiles.fincuvagermany.com/germany-2026-08.json"
    }
  },
  "layers": [
    {
      "id": "road-label",
      "type": "symbol",
      "source": "omt",
      "source-layer": "transportation_name",
      "minzoom": 13,
      "layout": {
        "visibility": "visible",
        "symbol-placement": "line",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Regular"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          13,
          9,
          18,
          12.6
        ]
      },
      "paint": {
        "text-color": "#d4d4d4",
        "text-halo-color": "rgba(255,255,255,0.9)",
        "text-halo-width": 1.2
      }
    },
    {
      "id": "poi-label",
      "type": "symbol",
      "source": "omt",
      "source-layer": "poi",
      "minzoom": 15,
      "filter": [
        "<=",
        [
          "get",
          "rank"
        ],
        3
      ],
      "layout": {
        "visibility": "none",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Regular"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          15,
          9,
          18,
          10.8
        ],
        "text-max-width": 8,
        "text-offset": [
          0,
          0.4
        ],
        "text-anchor": "top"
      },
      "paint": {
        "text-color": "#7d7a72",
        "text-halo-color": "rgba(255,255,255,0.9)",
        "text-halo-width": 1.1
      }
    },
    {
      "id": "place-other",
      "type": "symbol",
      "source": "omt",
      "source-layer": "place",
      "minzoom": 12,
      "filter": [
        "in",
        [
          "get",
          "class"
        ],
        [
          "literal",
          [
            "suburb",
            "hamlet",
            "neighbourhood",
            "isolated_dwelling"
          ]
        ]
      ],
      "layout": {
        "visibility": "visible",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Italic"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          12,
          9,
          16,
          11.7
        ],
        "text-transform": "none"
      },
      "paint": {
        "text-color": "#b8b8b8",
        "text-opacity": 0.8,
        "text-halo-color": "rgba(255,255,255,0.9)",
        "text-halo-width": 1.3
      }
    },
    {
      "id": "place-village",
      "type": "symbol",
      "source": "omt",
      "source-layer": "place",
      "minzoom": 10,
      "filter": [
        "==",
        [
          "get",
          "class"
        ],
        "village"
      ],
      "layout": {
        "visibility": "visible",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Regular"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          10,
          9.45,
          16,
          13.5
        ]
      },
      "paint": {
        "text-color": "#b8b8b8",
        "text-halo-color": "rgba(255,255,255,0.9)",
        "text-halo-width": 1.3
      }
    },
    {
      "id": "place-town",
      "type": "symbol",
      "source": "omt",
      "source-layer": "place",
      "minzoom": 8,
      "filter": [
        "==",
        [
          "get",
          "class"
        ],
        "town"
      ],
      "layout": {
        "visibility": "visible",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Regular"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          8,
          9.9,
          12,
          12.6,
          16,
          17.1
        ]
      },
      "paint": {
        "text-color": "#b8b8b8",
        "text-halo-color": "rgba(255,255,255,0.92)",
        "text-halo-width": 1.4
      }
    },
    {
      "id": "place-city",
      "type": "symbol",
      "source": "omt",
      "source-layer": "place",
      "minzoom": 5,
      "filter": [
        "==",
        [
          "get",
          "class"
        ],
        "city"
      ],
      "layout": {
        "visibility": "visible",
        "text-field": [
          "coalesce",
          [
            "get",
            "name:de"
          ],
          [
            "get",
            "name"
          ]
        ],
        "text-font": [
          "Noto Sans Bold"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          5,
          10.8,
          10,
          14.4,
          14,
          19.8
        ]
      },
      "paint": {
        "text-color": "#b8b8b8",
        "text-halo-color": "rgba(255,255,255,0.92)",
        "text-halo-width": 1.5
      }
    }
  ]
};

// The tileset TileJSON — MapView probes it at load to decide the Carto
// fallback; it is also exactly what MapLibre fetches first for a source.
export const BASEMAP_PROBE_URL = "https://tiles.fincuvagermany.com/germany-2026-08.json";
